import Header from "../Section/Header";
import Footer from "../Section/Footer";
import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  ScrollText,
  School,
  BrainCircuit,
  Target,
  Sparkles,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  astrologer_url,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import { CustomAlert } from "../../CommonJquery/CustomAlert";

export default function ExpertPage() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedAstrologer, setSelectedAstrologer] = useState(null);
  const [selectedTopic1, setSelectedTopic1] = useState([]);
  const [imagesLink, setImageLink] = useState("");
  const [astrodata, setAstrodata] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [imageLoaded, setImageLoaded] = useState(false);
  const handleCardClick = (astro) => {
    if (!astro?.astrology_id) return;

    const selected = astrodata.find(
      (a) => a.astrology_id === astro.astrology_id
    );
    if (!selected) return;

    setSelectedAstrologer({
      at_id: selected.at_id,
      astrology_id: selected.astrology_id,
      astro_name: selected.astro_name,
      astro_lang: selected.astro_lang,
      image: imagesLink + selected.astro_image,
      astro_exp: selected.astro_exp || "Not specified",
      astrology_name: selected.astrology_name || "Not specified",
      astro_education: selected.astro_education || "Not specified",
      astro_desc: selected.astro_desc || "No description available.",
    });
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const masterDataGet = async () => {
    await server_post_data(astrologer_url, null)
      .then((Response) => {
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          let final_data = JSON.parse(data[1]);

          setImageLink(final_data[0]["image_astrologer"]);

          setAstrodata(final_data[0]["astrologer_list"]);
          setFilteredData(final_data[0]["astrologer_list"]);

          setSelectedTopic1(final_data[0]["astrologer_type_list"]);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    masterDataGet();
  }, []);
  const handleNavigate = () => {
    navigate(
      "/experts/astrology-reading/" +
        selectedAstrologer.astrology_id +
        "/" +
        selectedAstrologer.at_id
    );
  };
  console.log("astrodata", astrodata);
  console.log("selectedAstrologer", selectedAstrologer);
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <section className="max-w-[1250px] mx-auto py-10 px-4">
          {/* Heading */}
          <div className="text-center mb-8">
            <h2 className="flex  gap-2 items-center mx-auto w-fit text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-4">
              <Sparkles color="#c781f3" size={32} strokeWidth={2.2} />
              Expert Astrologers
            </h2>
            <p className="text-lg text-purple-300 mb-6">
              Connect with experienced astrologers for personalized guidance
            </p>
          </div>

          {/* Astrologer Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {astrodata.length > 0 ? (
              astrodata.map((astro, index) => (
                <div
                  key={index}
                  onClick={() => handleCardClick(astro)}
                  className="rounded-2xl border border-purple-500/30 shadow-lg bg-slate-800/60 hover:shadow-purple-500/30 hover:border-purple-400/50 transition-all duration-300 hover:scale-[1.03] cursor-pointer backdrop-blur-lg overflow-hidden"
                >
                  <div className="p-6 flex flex-col items-center">
                    {!imageLoaded && (
                      <div className="w-24 h-24 rounded-full bg-gradient-to-r from-slate-700 via-slate-600 to-slate-700 animate-pulse mb-3" />
                    )}

                    <img
                      className={`w-24 h-24 rounded-full object-cover border-2 border-purple-500 shadow-md mb-3 transition-opacity duration-300 ${
                        imageLoaded ? "opacity-100" : "opacity-0"
                      }`}
                      src={imagesLink + astro.astro_image}
                      alt={astro.astro_name}
                      onLoad={() => setImageLoaded(true)}
                    />
                    <h3 className="text-xl font-bold text-purple-100">
                      {astro.astro_name}
                    </h3>
                    <p className="text-purple-300 text-sm mt-1">
                      {astro.astro_knowleage}
                    </p>
                    <p className="text-[var(--light-pink-color)] text-sm font-medium mt-[8px]">
                      {astro.astro_exp} Years of Experience
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-purple-300 py-10">
                No astrologers found.
              </div>
            )}
          </div>

          {/* Modal */}
          <Modal
            size="lg"
            show={showModal}
            onHide={handleClose}
            centered
            contentClassName="bg-slate-900 text-white rounded-xl"
          >
            <Modal.Header
              closeButton
              closeVariant="white"
              className="bg-slate-900 text-white border-b border-purple-500/20"
            >
              <Modal.Title className="text-purple-300 text-lg font-semibold">
                About Astrologer
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-slate-900 text-white">
              {selectedAstrologer && (
                <div className="text-center">
                  <img
                    src={selectedAstrologer.image}
                    alt={selectedAstrologer.astro_name}
                    className="rounded-full w-24 h-24 mx-auto mb-3 border-4 border-[var(--primary-color)] shadow-lg"
                  />

                  <h5 className="text-xl font-bold mb-1 text-purple-100">
                    {selectedAstrologer.astro_name}
                  </h5>
                  <p className="text-sm text-purple-300 mb-2">
                    {" "}
                    {selectedAstrologer.astro_lang}
                  </p>
                  <p className="text-sm text-purple-300 mb-3">
                    {" "}
                    {selectedAstrologer.astrology_name} |{" "}
                    {selectedAstrologer.astro_exp} Years of Experience
                  </p>

                  <div className="text-left space-y-3 text-purple-200">
                    {selectedAstrologer.astrology_name && (
                      <p className="flex gap-2 items-center">
                        <BrainCircuit className="w-4 h-4 text-[var(--light-pink-color)]" />
                        <span>
                          <b>Expertise:</b> {selectedAstrologer.astrology_name}
                        </span>
                      </p>
                    )}

                    <p className="flex gap-2 items-center">
                      <Target className="w-4 h-4 text-[var(--light-pink-color)]" />
                      <span>
                        <b>Focus Area:</b> Astrology
                      </span>
                    </p>

                    {selectedAstrologer.astro_education && (
                      <p className="flex gap-2 items-center">
                        <School className="w-4 h-4 text-[var(--light-pink-color)]" />
                        <span>
                          <b>Education:</b> {selectedAstrologer.astro_education}
                        </span>
                      </p>
                    )}
                    <p className="text-[16px] font-semibold border-b border-[var(--light-pink-color)] py-2 flex items-center gap-2">
                      <ScrollText className="w-4 h-4 text-[var(--light-pink-color)]" />{" "}
                      About the Astrologer
                    </p>
                    {selectedAstrologer.astro_desc && (
                      <p className="text-sm leading-relaxed">
                        {selectedAstrologer.astro_desc}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer className="bg-slate-900 border-t border-purple-500/20 justify-center">
              <Button
                variant="warning"
                className="bg-[var(--primary-color)] hover:bg-[var(--primary-hover-dark)] hover:text-[var(--light-pink-color)] border-none text-[var(--light-pink-color)] font-semibold text-[15px] px-4 py-2 rounded"
                onClick={handleNavigate}
              >
                Need Consultation ?
              </Button>
            </Modal.Footer>
          </Modal>
        </section>
      </div>
      <Footer />
    </>
  );
}
